import React, { useEffect, useState } from 'react';
import { X, Maximize2, Minimize2 } from 'lucide-react';
import YouTubePlayer from './YouTubePlayer';

const VideoPlayModal = ({ videoId, title, onClose }) => {
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        const onKeyDown = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.body.style.overflow = '';
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [onClose]);

    if (!videoId) return null;

    return (
        <div className="fixed inset-0 z-[80] flex items-center justify-center p-4 sm:p-6">
            <button
                type="button"
                aria-label="Close video"
                className="absolute inset-0 bg-black/60 backdrop-blur-sm"
                onClick={onClose}
            />
            <div
                className={`relative z-10 w-full overflow-hidden rounded-xl bg-gray-900 shadow-2xl border border-white/10 ${
                    expanded ? 'max-w-[min(96vw,1500px)]' : 'max-w-4xl'
                }`}
            >
                <div className="flex items-center justify-between gap-3 px-4 py-3 bg-black/40">
                    <h3 className="text-sm sm:text-base font-semibold text-white truncate pr-2">{title}</h3>
                    <div className="flex items-center gap-1 shrink-0">
                        <button
                            type="button"
                            onClick={() => setExpanded((prev) => !prev)}
                            className="rounded-lg p-2 text-gray-200 hover:bg-white/10 hover:text-white"
                            aria-label={expanded ? 'Shrink player' : 'Enlarge player'}
                        >
                            {expanded ? <Minimize2 className="w-4 h-4" /> : <Maximize2 className="w-4 h-4" />}
                        </button>
                        <button
                            type="button"
                            onClick={onClose}
                            className="rounded-lg p-2 text-gray-200 hover:bg-white/10 hover:text-white"
                            aria-label="Close video"
                        >
                            <X className="w-4 h-4" />
                        </button>
                    </div>
                </div>
                <YouTubePlayer videoId={videoId} title={title} fit="modal" autoPlay />
            </div>
        </div>
    );
};

export default VideoPlayModal;
